import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import styled from 'styled-components';
import { PatreonMark, PatreonWordmark } from '../../imagesAndIcons/Logo';
import { ItemVariant } from './components/Items/types';
import { Items } from './components/Items';
import { Search } from './components/Items/components/Search';
import { styledFactory } from '../../../utilities/styled-components';
import { Text } from '../../typography/Text';
export var LogoType;

(function (LogoType) {
  LogoType["Wordmark"] = "wordmark";
  LogoType["Mark"] = "mark";
})(LogoType || (LogoType = {}));

var TopNav =
/** @class */
function (_super) {
  __extends(TopNav, _super);

  function TopNav(props) {
    var _this = _super.call(this, props) || this;

    _this.renderLogo = function () {
      var _a = _this.props.logo,
          onClick = _a.onClick,
          type = _a.type,
          url = _a.url;
      var LogoComponent;
      var width;
      var height;

      switch (type) {
        case LogoType.Mark:
          LogoComponent = PatreonMark;
          width = 3;
          height = 3;
          break;

        case LogoType.Wordmark:
        default:
          LogoComponent = PatreonWordmark;
          width = 12;
          height = 4;
          break;
      }

      return React.createElement(LogoWrapper, {
        "aria-label": "Go to home page",
        href: url,
        onClick: onClick
      }, React.createElement(LogoComponent, {
        height: height,
        width: width
      }));
    };

    return _this;
  }

  TopNav.prototype.render = function () {
    var _a = this.props,
        items = _a.items,
        itemsRight = _a.itemsRight,
        itemsLeft = _a.itemsLeft,
        notFixed = _a.notFixed,
        title = _a.title;
    var rightItems = itemsRight || items;
    return React.createElement(NavWrapper, {
      notFixed: notFixed,
      title: title
    }, React.createElement(LeftWrapper, null, this.renderLogo(), itemsLeft && React.createElement(Items, {
      items: itemsLeft
    })), title && React.createElement(TitleWrapper, null, React.createElement(Text, {
      align: Text.Align.Center,
      el: Text.Element.H2,
      ellipsis: true,
      font: Text.Font.Title
    }, title)), React.createElement(RightWrapper, null, rightItems && React.createElement(Items, {
      items: rightItems,
      rightAlign: true
    })));
  };

  TopNav.ItemVariant = ItemVariant;
  TopNav.LogoType = LogoType;
  TopNav.Search = Search;
  TopNav.defaultProps = {
    logo: {
      type: LogoType.Wordmark,
      url: '/'
    }
  };
  return TopNav;
}(React.Component);

export { TopNav };
var NavWrapper = styledFactory(styled.header)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: center;\n    background-color: ", ";\n    border-bottom: ", ";\n    box-sizing: border-box;\n    display: grid;\n    grid-gap: ", ";\n    grid-template-columns: ", ";\n    grid-template-rows: ", ";\n    padding: ", ";\n    position: ", ";\n    width: 100%;\n"], ["\n    align-items: center;\n    background-color: ", ";\n    border-bottom: ", ";\n    box-sizing: border-box;\n    display: grid;\n    grid-gap: ", ";\n    grid-template-columns: ", ";\n    grid-template-rows: ", ";\n    padding: ", ";\n    position: ", ";\n    width: 100%;\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.strokeWidths["default"] + " solid " + props.theme.colors.gray4;
}, function (props) {
  return props.theme.units.getValue(2);
}, function (props) {
  return props.title ? '1fr auto 1fr' : 'auto auto';
}, function (props) {
  return props.theme.components.navigation.height;
}, function (props) {
  return "0 " + props.theme.units.getValue(2);
}, function (props) {
  return props.notFixed ? 'relative' : 'fixed';
});
var LeftWrapper = styledFactory(styled.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var RightWrapper = styledFactory(styled.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    justify-self: end;\n"], ["\n    justify-self: end;\n"])));
var LogoWrapper = styled.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n\n    &:hover {\n        opacity: 0.8;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n\n    &:hover {\n        opacity: 0.8;\n    }\n"])), function (props) {
  return props.theme.units.getValues([2, 2, 2, 0]);
});
export var TitleWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    overflow: hidden;\n"], ["\n    overflow: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;